/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShopProduct,
  NewShopProduct,
} from '../models/index';
import {
    ShopProductFromJSON,
    ShopProductToJSON,
    NewShopProductFromJSON,
    NewShopProductToJSON,
} from '../models/index';

export interface ShopProductCreateRequest {
    data?: NewShopProduct;
}

export interface ShopProductDeleteByIdRequest {
    id: string;
}

export interface ShopProductFindRequest {
    filter?: string;
}

export interface ShopProductFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ShopProductPrototypePatchAttributesRequest {
    id: string;
    data?: ShopProduct;
}

export interface ShopProductListForCustomerRequest {
    courierId: string;
}

/**
 * 
 */
export class ShopProductApi extends runtime.BaseAPI {

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopProductCreateRaw(requestParameters: ShopProductCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopProduct>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopProducts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewShopProductToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopProductFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopProductCreate(requestParameters: ShopProductCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopProduct> {
        const response = await this.shopProductCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopProductDeleteByIdRaw(requestParameters: ShopProductDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopProductDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopProducts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopProductDeleteById(requestParameters: ShopProductDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shopProductDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopProductFindRaw(requestParameters: ShopProductFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShopProduct>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopProducts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopProductFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopProductFind(requestParameters: ShopProductFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShopProduct>> {
        const response = await this.shopProductFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopProductFindByIdRaw(requestParameters: ShopProductFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopProduct>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopProductFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopProducts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopProductFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopProductFindById(requestParameters: ShopProductFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopProduct> {
        const response = await this.shopProductFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopProductPrototypePatchAttributesRaw(requestParameters: ShopProductPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopProduct>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopProductPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopProducts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShopProductToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopProductFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopProductPrototypePatchAttributes(requestParameters: ShopProductPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopProduct> {
        const response = await this.shopProductPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List products for customer
     */
    async shopProductListForCustomerRaw(requestParameters: ShopProductListForCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShopProduct>>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling shopProductListForCustomer().'
            );
        }

        const queryParameters: any = {};

        queryParameters['courierId'] = requestParameters['courierId'];

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopProducts/listForCustomer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopProductFromJSON));
    }

    /**
     * List products for customer
     */
    async shopProductListForCustomer(requestParameters: ShopProductListForCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShopProduct>> {
        const response = await this.shopProductListForCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
